export default __webpack_public_path__ + "static/media/directory-icon.9ddcf956.svg";